import * as React from 'react';
import useJackpotIncrement from '../../../hooks/useJackpotIncrement';
import { JackpotType } from '../../../types/gameTypes';
import styles from './JackpotLayer.module.scss';

type JackpotLayerProps = JackpotType;

const formatValue = (v: number): string => {
  return v
    .toLocaleString('en-gb', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })
    .replace(/,/g, ',');
};

const GT_JACKPOT_CURRENCY = 'gt-jackpot_currency';
const GT_JACKPOT_VALUE = 'gt-jackpot_value';

const JackpotLayer = ({
  value,
  currencySymbol,
  increaseVelocity,
  timestamp,
  updateInterval,
}: JackpotLayerProps) => {
  const jackpotValue = useJackpotIncrement(
    value,
    timestamp,
    increaseVelocity,
    updateInterval
  );
  return (
    <>
      {currencySymbol && (
        <span className={styles.text} data-testid={GT_JACKPOT_CURRENCY}>
          {currencySymbol}
        </span>
      )}
      <span className={styles.text} data-testid={GT_JACKPOT_VALUE}>
        {formatValue(jackpotValue)}
      </span>
    </>
  );
};

export default JackpotLayer;
